export const TicketType = {
  EPIC: "Epic",
  US: "User Story",
  TASK: "Task",
  SUB_TASK: "Subtask",
  BUG: "Bug",
  CS: "Customer Support",
};

export const TicketItemType = {
  BUDGET: "budget",
  EXPENDITURE: "expenditure",
};
